export default __webpack_public_path__ + "static/media/avatar.9d24c689.jpg";